import { Link } from "react-router-dom";
import { imgUrl } from "../lib/api";

export default function ProductCard({ product, priority = false }) {
  return (
    <Link
      to={`/shop/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group relative block overflow-hidden bg-stone-900/40 border border-stone-800 hover:border-amber-700/70 transition-colors duration-500"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-stone-950">
        <img
          src={imgUrl(product.images?.[0])}
          alt={product.name}
          loading={priority ? "eager" : "lazy"}
          className="absolute inset-0 w-full h-full object-contain p-4 transition-transform duration-[1.4s] ease-out group-hover:scale-[1.04]"
        />
        <div className="absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-stone-950 via-stone-950/80 to-transparent pointer-events-none" />
        {!product.in_stock && !product.external_url && (
          <div className="absolute top-4 left-4 bg-stone-950/80 backdrop-blur-sm text-stone-300 text-overline px-3 py-1 border border-stone-700">
            Sold
          </div>
        )}
        {product.external_url && (
          <div className="absolute top-4 left-4 bg-amber-700/90 backdrop-blur-sm text-stone-50 text-overline px-3 py-1">
            At partner shop
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8">
          <p className="text-overline text-amber-500 mb-2">{product.category}</p>
          <h3 className="font-display text-2xl sm:text-3xl font-bold text-stone-50 leading-tight">
            {product.name}
          </h3>
          <div className="flex items-end justify-between mt-4">
            <p className="text-stone-300 text-sm max-w-md leading-relaxed">
              {product.short_description}
            </p>
            <p className="font-display text-2xl text-stone-50 ml-4 shrink-0">
              ${product.price?.toFixed?.(0) ?? product.price}
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
}
